<label class="uploader" ondragover="return false;"
    [class.loaded]="loaded"
    [style.outlineColor]="dragging ? activeColor : baseColor"
    (dragenter)="handleDragEnter()"
    (dragleave)="handleDragLeave()"
    (drop)="handleDrop($event)">

    <i class="ei ei-cloud-upload"
        [style.color]="dragging
            ? ((imageSrc.length > 0) ? overlayColor : activeColor)
            : ((imageSrc.length > 0) ? overlayColor : baseColor)"></i>

    <img
        [src]="fullImageUrl"
        (load)="handleImageLoad()"
        [class.loaded]="imageLoaded"
        *ngIf="fullImageUrl"/>

    <input type="file" name="file" accept="image/*"
        (change)="handleInputChange($event)" [multiple]="multiple">

</label>
<ng-container *ngIf="progress as percent">
    <div class="row">
        <progress [value]="percent" max="100"></progress>
    </div>
</ng-container>
